import './turbo';
import './guides_location';
import './script_loader';
import './scroll_detection';
import './lateral_menu';
import './univers_metier_menu';
import './activity_video';
import './univers_metier_tracking';
import './loaders';
import './review';
import './share';
import { PopUpLink } from './pop_up_link';
import Tracking from './tracking';

new PopUpLink();
global.selectBottomMenu = (view) => import('./bottom_menu').then(module => module.selectBottomMenu(view));
global.menuLoader = (loaderHtml) => import('./bottom_menu').then(module => module.menuLoader(loaderHtml));
global.removeParamsFromUrl = (paramsToRemove) => import('./utils').then(module => module.removeParamsFromUrl(paramsToRemove));

globalThis.Tracking = Tracking;
window.dispatchEvent(new CustomEvent('TrackingReady'));

import('./remove_capitalkoala').then(module => module.cleanCapitalKoala());
import('./autoreplace');
